import React from "react";

import { AddToCalendarButton } from 'add-to-calendar-button-react';

import pseudoHtml from '../helpers/pseudoHtml';

type AddToCalButtonProps = {
  eventTitle: string,
  btnLabel?: string,
  eventDesc?: string,
  startDate: string,
  endDate?: string,
  startTime?: string,
  endTime?: string,
  eventLocation?: string,
  timezone?: string,
  compressed?: boolean,
};

const AddToCalButton: React.FC<AddToCalButtonProps> = ({ 
  eventTitle,
  btnLabel,
  eventDesc,
  startDate,
  endDate,
  startTime,
  endTime,
  eventLocation,
  timezone,
  compressed,
}) => {
  // Yes, they have to be absolute full paths. Yes, that's obnoxious.
  // See https://add-to-calendar-button.com/advanced-use
  const stylesheet = compressed ? 
    "https://upsun.com/stylesheets/atcb-custom--compressed.css" :
    "https://upsun.com/stylesheets/atcb-custom.css";

  return (
    <AddToCalendarButton
      name={eventTitle}
      label={btnLabel || "Add to calendar"}
      description={pseudoHtml(eventDesc || "")}
      startDate={startDate}
      endDate={endDate}
      startTime={startTime}
      endTime={endTime}
      location={eventLocation}
      timeZone={timezone || "America/New_York"}
      options={['Apple','Google','Yahoo','iCal','Outlook.com']}
      buttonStyle="custom"
      hideIconButton
      hideBackground
      hideCheckmark
      customCss={stylesheet}
    />
  )
};

export default AddToCalButton;
